import { immutableSelector } from 'utils/selectors'

export const root = (state) => state.get('router')
export const locationState = immutableSelector(root, (root) => root.toJS())
export const search = (state) => root(state).getIn(['locationBeforeTransitions', 'search'])
export const getQueryParams = immutableSelector(root, (root => root.getIn(['locationBeforeTransitions', 'query'])))

export const pathname = immutableSelector(root, root => root.getIn(['locationBeforeTransitions', 'pathname']))
export const onOnboarding = immutableSelector(pathname, pathname => pathname.indexOf('/welcome') !== -1)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/router/selectors.js